<template>
  <v-layout>
    <v-card class="card-indexed-pages">
      <v-card-title class="subheading font-weight-bold justify-center px-4">
        Top Organic Traffic Pages (of this domain)
        <!-- <a class="icon-help ml-1" href="https://support.kolyom.co.il/knowledge-base/power-pages/" target="_blank" title="Get more info >>>">
          <v-icon style="font-size: 18px;" >help_outline</v-icon>
        </a> -->
      </v-card-title>
      <!-- <div class="pb-1 text-xs-center">updated: {{ topTrafficPagesLastUpdate ? $moment(topTrafficPagesLastUpdate).format('DD-MM-YYYY') : '-' }}</div> -->
      <v-divider></v-divider>
      <v-list dense>
        <template>
          <v-data-table
            class="table-top-traffic-pages"
            :headers="headerTopTrafficPages"
            :items="topTrafficPages.length ? topTrafficPages.slice(0, 5) : []"
            :hide-actions="true"
            item-key="name"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th class="text-xs-center"></th>
                <template v-for="header in props.headers">
                  <th
                    :key="header.text"
                    :aria-sort="header.sortable ? '' : null"
                    :aria-label="header.text + ': Not sorted.'"
                    @click="return false"
                    :class="['column ', header.sortable ? 'sortable ' : '', header.align === 'middle' ? 'text-xs-center' : 'text-xs-left', header.visibility, !header.sort_padding || 'pr-3']"
                    :colspan="header.colspan ? header.colspan : 0"
                  >
                    <span @click="!header.sortable || changeSort(header.value)">
                      <!-- <v-icon v-if="header.sortable && (!header.align || header.align === 'right')">arrow_upward</v-icon> -->
                      <span v-html="header.text"></span>
                      <v-icon v-if="header.sortable && (header.align === 'left' || header.align === 'middle')">arrow_upward</v-icon>
                    </span>
                  </th>
                </template>
              </tr>
            </template>
            <template v-slot:items="props" v-if="topTrafficPages && topTrafficPages.length > 0">
              <tr>
                <td class="text-xs-center">
                  <v-tooltip top>
                    <img
                      slot="activator"
                      class="pointer"
                      :src="fishingIcon"
                      alt="Keywords fishing tool"
                      style="width: 25px;"
                      @click="selectedValue = props.item.url; fishingKeywordsDialog = true;"
                    >
                    <span>Keywords fishing tool</span>
                  </v-tooltip>
                </td>
                <td>
                  <a :href="props.item.url.includes('http') ? props.item.url : 'http://' + props.item.url" target="_blank" title="props.item.from_url" class="a-readmore" v-if="props.item.url"><read-more  more-str="show full URL" :text="props.item.url" link="#" less-str="hide" :max-chars="45"></read-more></a>
                </td>
                <td class="text-xs-center">{{ props.item.estimated }}</td>
                <td class="pl-2">{{ props.item.best_name }}</td>
                <td class="text-xs-center">{{ props.item.best_volume }}</td>
              </tr>
            </template>
            <template slot="no-data">
              <tr>
                <td class="text-xs-center" colspan="5">
                  <span v-if="isAdmin || this.$store.state.user.permissions.indexed_pages_box">No data available</span>
                  <v-btn v-else small class="white--text" color="orange" @click="$router.push({name: 'SubscriptionSettings'})" >
                    <v-icon>open_in_browser</v-icon> Upgrade package
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-list-tile v-if="topTrafficPages && topTrafficPages.length > 0">
          <v-list-tile-content :style="{ 'align-items':'center' }">
            <a @click="topTrafficPagesBoxDialog = true">View more</a>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
    <TopTrafficPagesBoxModal v-if="topTrafficPagesBoxDialog" :topTrafficPagesBoxDialog="topTrafficPagesBoxDialog" :project="project" :engineId="engineId"></TopTrafficPagesBoxModal>
    <FishingKeywordsModal
      v-if="fishingKeywordsDialog"
      :fishingKeywordsDialog="fishingKeywordsDialog"
      :project="project"
      :projectId="project.id"
      :engineId="engineId"
      :engines="project.engines"
      :method="$store.state.keyword.fishingMethods.url"
      :url="selectedValue"
    ></FishingKeywordsModal>
  </v-layout>
</template>

<script>
export default {
  name: 'TopTrafficPagesBox',
  props: ['project', 'engineId'],
  data () {
    return {
      isAdmin: this.$store.state.user.permissions.is_admin,
      fishingIcon: require('@/assets/img/fish.png'),
      loading: false,
      topTrafficPagesBoxDialog: false,
      fishingKeywordsDialog: false,
      fishingMethod: null,
      selectedValue: null,
      // topTrafficPagesLastUpdate: '',
      topTrafficPages: [],
      headerTopTrafficPages: [
        { text: 'Pages', value: 'url', sortable: false },
        { text: 'Estimated traffic', value: 'estimated', sortable: false, align: 'middle' },
        { text: 'Best Ranking Keyword with Volume', value: 'best_name', sortable: false, align: 'middle', colspan: 2 }
      ]
    }
  },
  mounted () {
    this.$on('topTrafficPagesBoxDialog', (value) => {
      this.topTrafficPagesBoxDialog = value
    })
    this.$on('fishingKeywordsDialog', (value) => {
      this.fishingKeywordsDialog = value
    })
    if (this.project) {
      this.getTopTrafficPages()
    }
  },
  computed: {
    available: function () {
      return this.isAdmin || this.$store.state.user.permissions.suggested_keywords_box
    }
  },
  watch: {
    project: {
      handler () {
        this.getTopTrafficPages()
      },
      deep: true
    },
    engineId: {
      handler () {
        if (this.project && this.project.id === parseInt(this.$route.params.id)) {
          this.getTopTrafficPages()
        }
      }
    }
  },
  beforeDestroy () {
    this.$off('topTrafficPagesBoxDialog')
    this.$off('fishingKeywordsDialog')
  },
  methods: {
    getTopTrafficPages () {
      if (this.isAdmin || this.$store.state.user.permissions.indexed_pages_box) {
        let params = {
          top: 5,
          engine_id: parseInt(this.engineId)
        }
        this.loading = true
        this.$store.dispatch('GET_TOP_TRAFFIC_PAGES', { projectId: this.project.id, params: params }).then(res => {
          this.topTrafficPages = res.power_pages
          this.loading = false
        }, err => {
          this.loading = false
          console.log('GET_TOP_TRAFFIC_PAGES error', err)
          let errorText = this.$services.getApiError(err)
          if (errorText) this.$eventEmitter.$emit('showAlert', 'error', 'Error occurred!', `<p>Error: "${errorText}"</p><p>Our technical support received this error and we will try to fix it ASAP</p>`)
        })
      }
    }
  }
}
</script>

<style lang="scss">

</style>

<style lang="scss" scoped>
  .table-top-traffic-pages .v-table thead tr th:first-child {
    padding-right: 0px !important;
  }
  .table-top-traffic-pages .v-table tbody td:first-child {
    padding-right: 0px !important;
  }
  .card-indexed-pages, .card-competitors {
    min-height: 404px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/project-boxes/TopTrafficPagesBox.vue